import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAdministrationCompany,
  updateProps,
} from '../../../contextRedux/AdministrationCompany/AdministrationCompanyModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { AdministrationCompanyColumn } from './AdministrationCompanyColumn';

const CompanyTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxAdministrationCompany = useSelector((state: RootState) => state.models?.administrationCompany);
  const administrationCompanies = useSelector((state: RootState) => state.store?.administrationCompany.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxAdministrationCompany.props.skip / reduxAdministrationCompany.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setAdministrationCompany(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxAdministrationCompany.props.take,
    total: reduxAdministrationCompany.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxAdministrationCompany.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={administrationCompanies ?? []}
        pagination={paginationConfig}
        columns={AdministrationCompanyColumn(handleEdit)}
        rowKey='id'
      />
    </>
  );
};

export default CompanyTable;
